import React from 'react';
import { Dialog } from 'primereact/dialog';

const InputNumberBDI = props => {

    return React.createElement(
        Dialog,
        {
            header: props.header,
            visible: props.visible,
            style: props.style,
            modal: true,
            footer: props.footer,
            onHide: props.funcao
        },
        props.children
    );
};

export default InputNumberBDI;